import { Typography } from "@material-ui/core";
import { FC, useEffect, useState } from "react";
import Loader from "../../../../components/Loader";
import { fetchRequestChangedTimes } from "../utils/requestChangedTimes";

const RequestDateStatus: FC<any> = (props) => {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("Accepted");

  useEffect(() => {
    (async function () {
      setLoading(true);
      try {
        const fetchedData: any = await fetchRequestChangedTimes(props.record, null);
        if (fetchedData) {
          setStatus(fetchedData.status);
        }
        setLoading(false);
      } catch (ex: any) {
        console.log(ex.message);
        setLoading(false);
      }
    })();
  }, []);

  return (
    <Loader loading={loading}>
      <Typography variant="body2">{status}</Typography>
    </Loader>
  );
};

export default RequestDateStatus;
